import { baseUrl } from './config'
import path from 'path'

export function usePath(uriFunctor = () => baseUrl, ...relativePathFragments) {
  const requestURL = new URL(uriFunctor())
  requestURL.pathname += path.join(...relativePathFragments)
  return requestURL
}

export function usePathFromBaseURI(...relativePathFragments) {
  return usePath(() => baseUrl, ...relativePathFragments)
}

export function useQuery(uriFunctor = () => baseUrl, ...queryParams) {
  const requestURL = new URL(uriFunctor())
  queryParams.forEach(item => {
    requestURL.searchParams.append(item.name, item.value != null ? item.value.toString() : 'null')
  })
  return requestURL
}